import MarkEmailRead from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnread from "@mui/icons-material/MarkEmailUnread";
import type { SvgIconProps } from "@mui/material/SvgIcon";

/**
 * The icons for a control that marks something read or unread (#6262).
 *
 * Each icon names the act the control performs, not the state the item is in: a read row offers
 * Mark Unread and shows `MarkUnreadIcon`. Every read-state control draws from here — the
 * Communications Inbox, the Notification bell, and the Correspondence panes, their Mark all read
 * buttons included — so the same act looks the same wherever it is offered.
 */
export function MarkReadIcon(props: Readonly<SvgIconProps>) {
  return <MarkEmailRead {...props} />;
}

export function MarkUnreadIcon(props: Readonly<SvgIconProps>) {
  return <MarkEmailUnread {...props} />;
}

/** The icon for a control that toggles read state: Mark Unread on a read item, Mark Read on an unread one. */
export function ReadStateToggleIcon(props: Readonly<SvgIconProps & { read: boolean }>) {
  const { read, ...iconProps } = props;
  return read ? <MarkUnreadIcon {...iconProps} /> : <MarkReadIcon {...iconProps} />;
}
